import { Component, Inject, OnInit, Optional } from '@angular/core';
import { HotToastRef, HotToastService, ToastType } from '@ngneat/hot-toast';
import { svgMenuMap } from '../../helpers/helpers';
import { get, includes, truncate } from 'lodash-es';


interface DataType {
  fact: string;
}

@Component({
  selector: 'app-common-toast',
  templateUrl: './common-toast.component.html',
  styleUrls: ['./common-toast.component.scss']
})
export class CommonToastComponent implements OnInit {
  data: any;
  toastIcon: any;
  content!: string;
  closeIcon = svgMenuMap.close;
  skipTruncateForIds = ['exportingUtilisationStats', 'exportedUtilisationStats', 'exportUtilisationStatsFailed'];
  constructor(@Optional() @Inject(HotToastRef) public toastRef: HotToastRef<DataType>, private toast: HotToastService) {
    this.data = toastRef.data;
  }

  ngOnInit(): void {
    if(this.data?.type === 'warning') {
      this.toastIcon = svgMenuMap.warningSvg
    } else if(this.data?.type === 'success') {
      this.toastIcon = svgMenuMap.checkMark
    } else if(this.data?.type === 'error') {
      this.toastIcon = svgMenuMap.dismissIcon
    }

    this.content = includes(this.skipTruncateForIds, this.data.id)
          ? get(this.data, "content")
          : truncate(get(this.data, "content"), { length: 50, omission: "..." });
  }

  dismiss() {
    if (this.toastRef) {
      this.toastRef.close();
    }
  }
  
}
